// Generated from build58 src/features/musicEdition/branding.ts; do not edit.
// Display name only. Keep routes/storage/native archive identifiers stable so
// renaming the feature never strands an existing saved edition.
export const musicEditionName = { ko: '나의 아카이브', en: 'My Archive' };
export const musicEditionCreateLabel = { ko: '나의 아카이브 만들기', en: 'Create my Archive' };
